import Vue from 'vue'

function waitForApiKey(maxWaitMs = 10000) {
  return new Promise((resolve) => {
    const start = Date.now()
    const check = () => {
      const apiKey =
        Vue.prototype?.$settings?.google_api_browser_key ||
        process.env.VUE_APP_GOOGLE_MAP_KEY
      if (apiKey) {
        resolve(apiKey)
        return
      }
      if (
        Vue.prototype?.$settings?._loaded ||
        Date.now() - start >= maxWaitMs
      ) {
        resolve(null)
        return
      }
      setTimeout(check, 100)
    }
    check()
  })
}

export function loadGoogleMaps(libs) {
  let interval = null

  return waitForApiKey().then((apiKey) => {
    return new Promise((resolve) => {
      if (window.google) {
        resolve()
        return
      }

      const scripts = document.querySelectorAll(
        'script[src^="https://maps.googleapis.com/maps/api/js"]'
      )

      if (!scripts || !scripts.length) {
        if (!apiKey) {
          const message = `No Google Maps API key is provided. Is VUE_APP_GOOGLE_MAP_KEY variable defined in .env.* file?`
          // eslint-disable-next-line no-console
          console.warn(message)
          resolve()
          return
        }

        const language = process.env.VUE_APP_GOOGLE_MAPS_LANGUAGE || 'en'
        let scriptSrc = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&language=${encodeURIComponent(
          language,
        )}`

        if (libs && libs.length)
          scriptSrc = `${scriptSrc}&libraries=${libs.join()}`

        const scriptEl = document.createElement('script')
        scriptEl.setAttribute('src', scriptSrc)
        document.head.appendChild(scriptEl)
      }

      interval = setInterval(() => {
        if (window.google) {
          clearInterval(interval)
          resolve()
        }
      }, 200)
    })
  })
}
